module.exports = __webpack_public_path__ + "media/images/baja-df31bb8069231767f84b6204ae6f51ad.svg";